import { Box, Icon } from '@zillow/constellation-10';
import {
  IconPauseCircleFilled,
  IconUnconstrainedWalkThroughFilled,
  IconUserAddFilled,
} from '@zillow/constellation-icons';

import AnswerCard from './AnswerCard';
import { ANSWER_CARD_CONFIG, DEACTIVATION_REASONS, type DeactivationReason } from '../constants';
import TenantDirectoryCSEvents from '../../../../model/ClickstreamEvent/TenantDirectoryCSEvents';

type DeactivationReasonStepProps = {
  deactivationReason: DeactivationReason | null;
  onAnswerSelect: (answer: DeactivationReason) => void;
};

const getTitle = (reason: DeactivationReason): string =>
  ANSWER_CARD_CONFIG.find((config) => config.reason === reason)?.title ?? '';

const DeactivationReasonStep = ({ deactivationReason, onAnswerSelect }: DeactivationReasonStepProps) => {
  return (
    <Box data-testid="DeactivationReasonStep" css={{ display: 'flex', flexDirection: 'column', gap: '400' }}>
      <AnswerCard
        data-testid="AnswerCardFoundTenant"
        data-event-id={TenantDirectoryCSEvents.DeactivationReasonClick.data_event_id}
        icon={
          <Icon size="lg">
            <IconUserAddFilled />
          </Icon>
        }
        title={getTitle(DEACTIVATION_REASONS.FOUND_RENTER_ELSEWHERE)}
        isSelected={deactivationReason === DEACTIVATION_REASONS.FOUND_RENTER_ELSEWHERE}
        onClick={() => onAnswerSelect(DEACTIVATION_REASONS.FOUND_RENTER_ELSEWHERE)}
      />
      <AnswerCard
        data-testid="AnswerCardTenantRenewed"
        data-event-id={TenantDirectoryCSEvents.DeactivationReasonClick.data_event_id}
        icon={
          <Icon size="lg">
            <IconUnconstrainedWalkThroughFilled />
          </Icon>
        }
        title={getTitle(DEACTIVATION_REASONS.TENANT_RENEWED)}
        isSelected={deactivationReason === DEACTIVATION_REASONS.TENANT_RENEWED}
        onClick={() => onAnswerSelect(DEACTIVATION_REASONS.TENANT_RENEWED)}
      />
      <AnswerCard
        data-testid="AnswerCardStillLookingPausing"
        data-event-id={TenantDirectoryCSEvents.DeactivationReasonClick.data_event_id}
        icon={
          <Icon size="lg">
            <IconPauseCircleFilled />
          </Icon>
        }
        title={getTitle(DEACTIVATION_REASONS.STILL_LOOKING_PAUSING_ON_ZILLOW)}
        isSelected={deactivationReason === DEACTIVATION_REASONS.STILL_LOOKING_PAUSING_ON_ZILLOW}
        onClick={() => onAnswerSelect(DEACTIVATION_REASONS.STILL_LOOKING_PAUSING_ON_ZILLOW)}
      />
    </Box>
  );
};

export default DeactivationReasonStep;
